/**
 *   File:   attorney-toggle.js
 *   Desc:   apply the aria-expand attribute properly according to the status of the toggle
 */

export default class AttorneyToggle {
	static TOGGLE_ITEM_SELECTOR = '.et_pb_toggle.et_pb_toggle_item';
	static TOGGLE_SELECTOR= '.et_pb_toggle.et_pb_toggle_item .et_pb_toggle_title';

	start() {
		if (!$(AttorneyToggle.TOGGLE_ITEM_SELECTOR).length) {
			return;
		}
		this.attachListeners();
	}

	attachListeners() {
		this.toggleExpand();
	}

	toggleExpand() {
		const $ = jQuery;
		$(window).load(() => {
			$(AttorneyToggle.TOGGLE_SELECTOR).on('click', function () {
				const $element = $(this);
				if ($element.parent().parent().hasClass('et_pb_toggle_close')) {
					$element.attr('aria-expanded', 'true');
				} else {
					$element.attr('aria-expanded', 'false');
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/divi/controllers/attorney-toggle.js